import { baseURL } from '../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { trimData } from '../utilities/TrimPayloadData';
import { loadingAction } from '../redux/actions/loadingAction';
import { showMessageAction } from '../redux/actions/showMessageAction';
import store from '../redux/store';

export const handlePostRequest =
    (data, url, isShowLoad = false, isShowToast = true, nextPageToLoad = '', responseCode = '', isMultipart = false) =>
    async (dispatch) => {
        // Only trim data if it's not FormData
        if (!isMultipart) {
            data = await trimData(data);
        }
        console.log('DATA', data);
        try {
            if (isShowLoad) dispatch(loadingAction(true));
            const config = {
                method: 'post',
                url: `${baseURL}${url}`,
                headers: {}
            };

            const token = sessionStorage.getItem('token');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            // Set Content-Type header based on data type
            if (isMultipart || data instanceof FormData) {
                // For FormData, don't set Content-Type, axios will set it automatically with boundary
                config.data = data;
            } else {
                config.data = data;
                config.headers['Content-Type'] = 'application/json';
            }

            const response = await axios(config);
            console.log('API RESPONSE:', response);

            if (response?.data?.message === 'Invalid Token' || response?.data?.message === 'Session Expired') {
                localStorage.clear();
                setTimeout(() => {
                    window.location.href = '/';
                }, 1000);
            }

            if (isShowToast) {
                if (response?.data?.message === 'Validations Failed') {
                    // Display a warning toast with validation errors
                    toast.warn(
                        response?.data?.errors
                            ?.filter((value) => value?.errorDescr === 'Select Any One Option')
                            ?.map((filteredError) => filteredError?.errorDescr)
                            .join(', '),
                        { autoClose: 2000 }
                    );
                } else if (
                    response?.data?.message === 'This record is already pending for approval' ||
                    response?.data?.message === 'Record Not Found' ||
                    response?.data?.message === 'Record Already Exist' ||
                    response?.data?.message === 'Mobile Number Already Exist' ||
                    response?.data?.message === 'Cnic Already Exist' ||
                    response?.data?.message === 'Ntn Already Exist' ||
                    response?.data?.message === 'Email Already Exist'
                ) {
                    toast.warn(response?.data?.message || response?.data?.messages || response?.data?.error || 'Something went wrong !!', { autoClose: 2000 });
                } else {
                    if (responseCode == '' || responseCode === response?.data?.responseCode) {
                        // Display a success toast
                        toast.success(response?.data?.message || response?.data?.messages || response?.data?.error || 'Something went wrong !!', { autoClose: 2000 });
                    } else {
                        toast.warn(response?.data?.message || response?.data?.messages || response?.data?.error || 'Something went wrong !!', { autoClose: 2000 });
                    }
                }
            } else if (response?.data?.message === 'Validations Failed') {
                store.dispatch(
                    showMessageAction({
                        isShowModal: true,
                        message: (response?.data?.message === 'Validations Failed' ? response?.data?.errors?.map((value) => value?.errorDescr) : response?.data?.message) || 'Something went wrong !!',
                        isError: true
                    })
                );
            } else if (
                response?.data?.message === 'This record is already pending for approval' ||
                response?.data?.message === 'Record Already Exist' ||
                response?.data?.message === 'Record Not Found' ||
                response?.data?.message === 'Mobile Number Already Exist' ||
                response?.data?.message === 'Cnic Already Exist' ||
                response?.data?.message === 'Ntn Already Exist' ||
                response?.data?.message === 'Email Already Exist'
            ) {
                store.dispatch(
                    showMessageAction({
                        isShowModal: true,
                        message: response?.data?.message || 'Something Went Wrong',
                        isError: true
                    })
                );
            } else {
                if (responseCode == '' || responseCode === response?.data?.responseCode) {
                    store.dispatch(
                        showMessageAction({
                            isShowModal: false,
                            message: response?.data?.message || 'Success',
                            isError: false,
                            url: nextPageToLoad
                        })
                    );
                } else {
                    store.dispatch(
                        showMessageAction({
                            isShowModal: true,
                            message: response?.data?.message || 'Something Went Wrong',
                            isError: true
                        })
                    );
                }
            }
            if (isShowLoad) dispatch(loadingAction(false));

            return response?.data;
        } catch (error) {
            console.error('Axios error details:', error);
            if (error?.response?.data?.message === 'Invalid Token' || error?.response?.data?.message === 'Session Expired') {
                localStorage.clear();
                setTimeout(() => {
                    window.location.href = '/';
                }, 1000);
            }
            if (isShowLoad) dispatch(loadingAction(false));
            if (isShowToast === false) {
                store.dispatch(
                    showMessageAction({
                        isShowModal: true,
                        message: (error?.response?.data?.message === 'Validations Failed' ? error?.response?.data?.errors?.map((value) => value?.errorDescr) : error?.response?.data?.message) || 'Something went wrong !!',
                        isError: true
                    })
                );
            }
            // else if (error?.response?.status === 500 && isShowToast) {
            //     toast.warn({
            //         render: error?.response?.data?.message || error?.response?.data?.messages || error?.response?.data?.error || 'Something went wrong !!',
            //         type: 'error',
            //         isLoading: false,
            //         autoClose: 3000
            //     });
            // } else if (error?.response?.status === 400 && isShowToast)
            //     toast.warn({
            //         render: error?.response?.data?.message || error?.response?.data?.messages || error?.response?.data?.error || 'Something went wrong !!',
            //         type: 'error',
            //         isLoading: false,
            //         autoClose: 3000
            //     });
            // else if (isShowToast)
            //     toast.warn({
            //         render: error?.response?.data?.message || error?.response?.data?.messages || error?.response?.data?.error || 'Something went wrong !!',
            //         type: 'error',
            //         isLoading: false,
            //         autoClose: 3000
            //     });
            else if (error?.response?.status === 500 && isShowToast) {
                toast.warn(error?.response?.data?.message || error?.response?.data?.messages || error?.response?.data?.error || 'Something went wrong !!', { autoClose: 2000 });
            } else if (error?.response?.status === 400 && isShowToast)
                toast.warn(
                    error?.response?.data?.message === 'Validations Failed'
                        ? error?.response?.data?.errors
                              ?.filter((value) => value?.errorDescr === 'Select Any One Option')
                              ?.map((filteredError) => filteredError?.errorDescr)
                              .join(', ') || error?.response?.data?.errors?.map((filteredError) => filteredError?.errorDescr).join(', ')
                        : error?.response?.data?.message || error?.response?.data?.messages || error?.response?.data?.error || 'Something went wrong !!',
                    { autoClose: 2000 }
                );
            else if (error?.response?.status === 401 && isShowToast) {
                sessionStorage.removeItem('token');
            } else toast.warn(error?.response?.data?.message || 'Something went wrong !!');
            return error?.response;
        }
    };
